import React from 'react';
import PageContainer from '../../components/PageContainer/index';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import LicenseDisplay from './components/LicenseDisplay/index';
import ClientsTable from './components/ClientsTable/index';
import InviteClients from './components/InviteClients/index';

import style from './Clients.module.scss';

const Clients = ({ totalSize }) => (
  <>
    <LicenseDisplay />
    <div className={style.addClientsContainer}>
      <PageContainer>
        <div className={style.addClientsRow}>
          {totalSize > 0 && <InviteClients />}
        </div>
      </PageContainer>
    </div>
    <ClientsTable />
  </>
);

const mapStateToProps = ({ clientsReducer }) => ({
  totalSize: clientsReducer.totalSize,
});

export default connect(mapStateToProps)(Clients);

Clients.propTypes = {
  totalSize: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
};
